import React from 'react';
import ReactApexChart from 'react-apexcharts';

const GraficaOXI = ({ series }) => {
    const colors = ['#1983c4', '#48457c', '#a92a41', '#c1c1c1']
    const labels = ['Normal', 'Hipoxia leve', 'Hipoxia moderada', 'Sin registro']


    const total = series.reduce((acc, val) => acc + val, 0);
    const options = {
        series: series,
        chart: {
            width: 500,
            type: 'donut',
        },
        plotOptions: {
            pie: {
                startAngle: -90,
                endAngle: 270,
            },
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '14px',
            },
            formatter: function (val, opts) {
                return opts.w.globals.series[opts.seriesIndex];
            },
        },
        tooltip: {
            custom: function ({ seriesIndex, dataPointIndex, w }) {
                const color = colors[seriesIndex];
                const label = labels[seriesIndex];
                const valor = ((series[seriesIndex] / total) * 100).toFixed(1);

                return (
                    '<div className="custom-tooltip" style="width: 155px; font-size: 12px; border-radius: 10%; text-align: center;">' +
                    '<div className="tooltip-label" style="background-color: ' + color + '; color: white; padding: 5px 0;">' +
                    label +
                    '</div>' +
                    '<div className="tooltip-content" style="display: flex; align-items: center; background-color:#dadde9; padding: 5px 10px; background-color:white">' +
                    '<div className="sales-circle" style="background-color: ' + color + '; border-radius: 50%; width: 10px; height: 10px;"></div>' +
                    '<div className="sales-value" style="font-weight: bold; margin-left: 20px;color:black">' +
                    valor + '%' + // Mostrar el valor como porcentaje con un decimal
                    '</div>' +
                    '</div>' +
                    '</div>'
                );
            },
        },
        fill: {
            type: 'gradient',
        },
        legend: {
            offsetY: 50,
            offsetX: 10,
            fontSize: '16px',
            formatter: function (val, opts) {
                return val + ' - ' + opts.w.globals.series[opts.seriesIndex];
            },
        },

        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ],
        labels: labels,
        colors: colors,
    };

    return (
        <div id="chart">
            <ReactApexChart options={options} series={options.series} type="donut" width={500} />
            <div className={total === 0 ? "total-valueIMC0" : "total-valueIMC"}>{total}</div>
            <div className={total === 0 ? "total-IMC0" : "total-IMC"}>Total</div>
        </div>
    );
};

export default GraficaOXI;
